/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const moon = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.25 2.53a6.204 6.204 0 0 1 1.08 3.09c.146 2.387-1.046 4.65-3.066 5.824a5.584 5.584 0 0 1-1.997.707.93.93 0 0 0-.75.75.957.957 0 0 0 .421.988 6.694 6.694 0 0 0 7.522-.09c2.267-1.568 3.417-4.373 2.93-7.143-.489-2.77-2.522-4.978-5.18-5.625a.91.91 0 0 0-.998.397.975.975 0 0 0 .039 1.104Z"
      clipRule="evenodd"
    />
  </svg>
)
export default moon
